import listSaga from './listSaga'

const transactionsSagas = [listSaga()]

export default transactionsSagas
